import mod from "-!./User.js?vue&type=script&lang=js&"; export default mod; export * from "-!./User.js?vue&type=script&lang=js&"